import { useSyncExternalStore } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { AlertTriangle, RefreshCw, MessageCircle, Phone } from "lucide-react";
import {
	subscribeToRateLimitDialog,
	getRateLimitDialogSnapshot,
} from "./supabaseClient";

declare global {
	interface Window {
		Intercom: (command: string, message?: string) => void;
	}
}

export const RateLimitDialog: React.FC = () => {
	const dialogData = useSyncExternalStore(
		subscribeToRateLimitDialog,
		getRateLimitDialogSnapshot
	);

	const handleReload = () => {
		window.location.reload();
	};

	const handleContactSupport = () => {
		const message = `Ich habe ein Rate-Limit Problem.\n\n${dialogData.recentCalls}`;
		if (window.Intercom) {
			window.Intercom("showNewMessage", message);
		} else {
			navigator.clipboard.writeText(message);
			alert(
				"Support-Info in Zwischenablage kopiert. Bitte kontaktieren Sie den Support."
			);
		}
	};

	if (!dialogData.open) return null;

	return (
		<DialogPrimitive.Root open>
			<DialogPrimitive.Portal container={document.body}>
				<DialogPrimitive.Overlay
					className="fixed inset-0 bg-black/80"
					style={{ zIndex: 2147483000 }}
				/>
				<DialogPrimitive.Content
					className="fixed left-1/2 top-1/2 w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg border bg-white p-6 shadow-lg"
					style={{ zIndex: 2147483001 }}
					onEscapeKeyDown={(e) => e.preventDefault()}
					onPointerDownOutside={(e) => e.preventDefault()}
					onInteractOutside={(e) => e.preventDefault()}
				>
					<div className="flex items-start gap-4">
						<AlertTriangle className="h-10 w-10 text-amber-500 shrink-0" />
						<div>
							<DialogPrimitive.Title className="text-lg font-semibold">
								Zu viele Anfragen
							</DialogPrimitive.Title>
							<DialogPrimitive.Description className="mt-2 text-sm text-gray-600">
								Die Anwendung hat ungewöhnlich viele
								Datenbankanfragen gesendet. Dies deutet auf ein
								technisches Problem hin.
								<br />
								<br />
								Bitte laden Sie die Seite neu. Falls das Problem
								weiterhin besteht, kontaktieren Sie den Support.
							</DialogPrimitive.Description>
						</div>
					</div>

					<div className="mt-6 flex flex-col gap-3">
						<button
							onClick={handleReload}
							className="flex items-center justify-center gap-2 rounded-md bg-amber-500 px-4 py-3 text-sm font-medium text-white hover:bg-amber-600 transition-colors"
						>
							<RefreshCw className="h-4 w-4" />
							Seite neu laden
						</button>
						<button
							onClick={handleContactSupport}
							className="flex items-center justify-center gap-2 rounded-md bg-gray-100 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-200 transition-colors"
						>
							<MessageCircle className="h-4 w-4" />
							Support-Chat öffnen
						</button>
						<p className="text-xs text-gray-500 px-1">
							In den Chat wird automatisch der Fehlerbericht mit
							wichtigen Informationen zur Analyse eingefügt.
						</p>
						<div className="flex items-center justify-center gap-2 pt-2 border-t border-gray-200">
							<Phone className="h-4 w-4 text-gray-500" />
							<a
								href="tel:+41315619327"
								className="text-sm text-gray-600 hover:text-gray-900"
							>
								031 561 93 27
							</a>
						</div>
					</div>
				</DialogPrimitive.Content>
			</DialogPrimitive.Portal>
		</DialogPrimitive.Root>
	);
};
